import {PlayersStatisticsTableRowMemberRowDomainModel} from "./players-statistics.table.row.member-row.domain-model";
import {LineupsMemberViewModel} from "../../../../lineups-member/lineups-member-view-model";
import {PlayersStatisticsTableRowViewModel} from "../players-statistics.table.row.view-model";

export class PlayersStatisticsTableRowMemberRowViewModel extends PlayersStatisticsTableRowViewModel {
  domainModel: PlayersStatisticsTableRowMemberRowDomainModel;

  get member(): LineupsMemberViewModel {
    const member: LineupsMemberViewModel = new LineupsMemberViewModel(this.domainModel.member);

    return member;
  }

  get num(): Number {
    return this.domainModel.num;
  }

  get groupId(): Number {
    return this.domainModel.groupId;
  }

  get shouldRenderEmptyState(): Boolean {
    return !this.hasValues && !this.shouldRenderDidNotPlay;
  }

  get shouldRenderDidNotPlay(): Boolean {
    return this.member.didNotPlayed;
  }

  get didNotPlayReason(): String {
    return this.member.didNotPlayedReason;
  }

  get emptyCellValue(): String {
    let emptyCellValue = '0';

    if(this.shouldRenderDidNotPlay) {
      emptyCellValue = '';
    }

    return emptyCellValue;
  }
}
